import * as React from 'react';
import { getValidator, rules } from '@Utils/shared/validator';
import useWidget from '@Utils/core/useWidget';
import { WidgetId } from '@Utils/edge/constants';
import GeneratorContext from '../GeneratorContext';

const validationRules = {
  username: [rules.username],
};

const useValidateNickname = () => {
  const widgetGeneratorGlobalV3 = useWidget(WidgetId.GeneratorGlobalV3);
  const context = React.useContext(GeneratorContext);

  const localizedErrors = {
    username: widgetGeneratorGlobalV3.strings.validateError,
  };

  const validatorInit = getValidator(validationRules, localizedErrors);

  const validator = React.useCallback(
    (nickname: string) => {
      validatorInit({ username: nickname }).then(
        () => {
          context.setShowErrorMessage(false);
        },
        () => {
          context.setShowErrorMessage(true);
        },
      );
    },
    [context, validatorInit],
  );

  return {
    validator,
  };
};

export default useValidateNickname;
